import './assets/app.css';
import Home from "./views/Home";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
        <Routes>
            <Route path="post/:pitchId" element={<Home />} />
            <Route path="posts/:pitchId" element={<Home />} />
            <Route path="pitch/:pitchId" element={<Home />} />
            <Route path="*" element={<Home />} />
        </Routes>
        <footer className="footer">
            <div className="container">
                <div className="row">
                    <p>© 2023 Kaizhan Ltd trading as VIA Academy.</p>
                    <ul>
                        <li>
                            <a href="https://www.viaacademy.com/">Homepage</a>
                        </li>
                        <li>
                            <a href="https://www.viaacademy.com/privacy">Privacy policy</a>
                        </li>
                        <li>
                            <a href="https://www.viaacademy.com/terms">App Terms and conditions</a>
                        </li>
                        {/*<li>*/}
                        {/*    <a href="https://www.viaacademy.com/terms-website">Website Terms and conditions</a>*/}
                        {/*</li>*/}
                    </ul>
                </div>
            </div>
        </footer>
    </div>
  );
}

export default App;
